"use client";

import { useEffect } from "react";
import { findHomepageSection } from "@/lib/layout/learn-section";

/** Scroll to a homepage hash after navigation. Shared by both headers. */
export function useHomepageHashScroll() {
  useEffect(() => {
    const handleHashNavigation = () => {
      const hash = window.location.hash.replace("#", "");
      if (!hash) return;
      const section = findHomepageSection(hash);
      if (!section) return;
      window.setTimeout(() => {
        section.scrollIntoView({ behavior: "smooth" });
      }, 300);
    };

    handleHashNavigation();
    window.addEventListener("hashchange", handleHashNavigation);
    return () => {
      window.removeEventListener("hashchange", handleHashNavigation);
    };
  }, []);
}
